import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';

let INFO_JSON2 = [
  {
    "id": "1",
    "label": "AM"
  },
  {
    "id": "2",
    "label": "PM"
  },
  {
    "id": "3",
    "label": "Todo el día"
  },
];

let INFO_JSON3 = [
  {
    id : "1",
    reason : "Arsen Ingenieria Ltda.",
    name : "Arsen",
  },
  {
    id : "2",
    reason : "Atacama Minerals Chile S.C.M",
    name : "Atacama Minerals",    
  },
  {
    id : "3",
    reason : "Cemento Polpaico S.A.",
    name : "Cemento Polpaico",
  },
  {
    id : "4",
    reason : "Compañía Cervecerias Unidas S.A.",
    name : "Ccu",
  },
  {
    id : "5",
    reason : "Complejo Industrial Molynor S.A.",
    name : "Molynor",
  },
];

@Component({
  selector: 'app-visit-modal',
  templateUrl: './visit-modal.component.html',
  styleUrls: ['./visit-modal.component.css']
})
export class VisitModalComponent implements OnInit {

  title: string;
  dataJson: string;  
  minDate = moment();

  newVisit = new FormGroup({
    dateActivity: new FormControl(null, { validators: Validators.required }),
    timeDayActivity: new FormControl(null, { validators: Validators.required }),
    clientActivity: new FormControl(null, { validators: Validators.required }),
    clientLabelActivity: new FormControl(null),
    descriptionActivity: new FormControl(null, { validators: Validators.required }),
    event_type: new FormControl(2, { validators: Validators.required }),
  });

  timeDayList = INFO_JSON2;
  clientActivityList = INFO_JSON3;

  constructor(public dialogRef: MatDialogRef<VisitModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VisitModalComponent) {
    this.title = data.title;
    this.dataJson = data.dataJson;
  }

  ngOnInit() {
    if (this.dataJson != null){
      this.newVisit.controls['dateActivity'].setValue(this.dataJson['dateActivity']);
      this.newVisit.controls['timeDayActivity'].setValue(this.dataJson['timeDayActivity']);
      this.newVisit.controls['clientActivity'].setValue(this.dataJson['clientActivity']);
      this.newVisit.controls['descriptionActivity'].setValue(this.dataJson['descriptionActivity']);
    }
  }

  onConfirm(): void {
    if (this.dataJson != null) {
      // es para Editar y Actualizar DATA
      if (this.newVisit.valid){
        this.newVisit.controls['clientLabelActivity'].setValue(this.getLabelType(this.newVisit.controls['clientActivity'].value));
        let response = {data: this.newVisit.value, status: true, hasNew: false}
        this.dialogRef.close(response);
      }
    } else {
      // Es para Crear una visita
      if (this.newVisit.valid){
        this.newVisit.controls['clientLabelActivity'].setValue(this.getLabelType(this.newVisit.controls['clientActivity'].value));
        let response = {data: this.newVisit.value, status: true, hasNew: true}
        this.dialogRef.close(response);
      }
    }
  }

  onDismiss(): void {
    let response = {data: null, status: false}
    this.dialogRef.close(response);
  }

  getLabelType(id) {
    let clientName = 'S/N';
    for (let type of INFO_JSON3) {
      if (type.id == id){
        clientName = type.reason
      }
    }
    return clientName;
  }

}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
 export class VisitModalModel {

  constructor(public title: string, public dataJson: string) {
  }
}
